import type { ReactNode, SVGProps } from "react";

export function RequestIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 13 14"
			width="13"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4.15412 12.625H2.15441C1.74879 12.625 1.35977 12.467 1.07295 12.1857C0.786134 11.9044 0.625 11.5228 0.625 11.125V2.125C0.625 1.72718 0.786134 1.34564 1.07295 1.06434C1.35977 0.783035 1.74879 0.625 2.15441 0.625H8.27206C8.67768 0.625 9.0667 0.783035 9.35352 1.06434C9.64034 1.34564 9.80147 1.72718 9.80147 2.125V8.125"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M7.50732 11.875L9.03674 13.375L12.0956 10.375"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M3.68408 3.625H6.74291"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
			<path
				d="M3.68408 6.625H5.21349"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.25"
			/>
		</svg>
	);
}
